import { Axios } from '../axios'

const evaluatePerformance = async (payload) => {
  const { data } = await Axios.post('/mobile/performances/evaluate', payload)
  return data
}

const advancedEvaluatePerformance = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluations/advanced',
    payload
  )
  return data
}

const getPerformances = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  let source = payload.source ? '&source=' + payload.source : "&source=''"
  let source_id = payload.source_id ? '&source_id=' + payload.source_id : null
  const { data } = await Axios.get(
    `/mobile/performances?limit=${payload.limit}&page=${payload.page}${filter}${search}${source_id}${source}`
  )
  return data?.data
}

const getPerformancesBySource = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  let source = payload.source ? '&source=' + payload.source : "&source=''"
  let source_id = payload.source_id ? '&source_id=' + payload.source_id : null
  const { data } = await Axios.get(
    `/mobile/performances/by-source?limit=${payload.limit}&page=${payload.page}${filter}${search}${source_id}${source}`
  )
  return data?.data
}

const getPerformanceSummary = async () => {
  const { data } = await Axios.post('/mobile/performances/summary')
  return data?.data
}

const gradeBasicPerformance = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluations/grade-basic/' + payload.id,
    payload.data
  )
  return data
}

const updateTrainingRequirements = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluations/update-training-requirement/' + payload.id,
    payload.data
  )
  return data
}

const updateReviewerComment = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluations/update-reviewer-comment/' + payload.id,
    payload.data
  )
  return data
}

const getPerformanceWorkflows = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  const { data } = await Axios.get(
    `/mobile/performances/workflows?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}

const getPerformanceWorkflow = async (payload) => {
  const { data } = await Axios.get(
    '/performance-evaluation/workflows/' + payload
  )
  return data?.data
}

const addPerformanceWorkflow = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluation/workflows',
    payload
  )
  return data
}

const updatePerformanceWorkflow = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/performance-evaluation/workflows/' + payload.id,
    payload.data
  )
  return data
}

const getPerformance = async (payload) => {
  const { data } = await Axios.get('/mobile/performance/' + payload)
  return data?.data
}

const getPerformanceBySource = async (payload) => {
  const { data } = await Axios.get('/mobile/performance/by-source/' + payload)
  return data?.data
}

const getPerformancesByEmployee = async (payload) => {
  const { source, sourceId, limit, page, search, start_date, end_date } =
    payload

  let startDateQuery = start_date ? `&start_date=${start_date}` : ''
  let endDateQuery = end_date ? `&end_date=${end_date}` : ''
  let searchQuery = search ? `&search=${search}` : ''

  const { data } = await Axios.get(
    `/mobile/performance/employees/${source}/${sourceId}?limit=${limit}&page=${page}${searchQuery}${startDateQuery}${endDateQuery}`
  )

  return data?.data
}

const deletePerformance = async (payload) => {
  const { data } = await Axios.delete(
    `/mobile/performance-evaluations/${payload}`
  )
  return data
}

//OKRS
const getPerformanceOkrs = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let source = payload.source ? '&source=' + payload.source : "&source=''"
  let source_id = payload.source_id ? '&source_id=' + payload.source_id : null
  const { data } = await Axios.get(
    `/mobile/performance-evaluation-okrs?limit=${payload.limit}&page=${payload.page}${search}${source}${source_id}`
  )
  return data?.data
}

const addPerformanceOKR = async (payload) => {
  const { data } = await Axios.post('/mobile/performance-okrs', payload)
  return data
}

const updatePerformanceOKR = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/performance-okrs/' + payload.id,
    payload.data
  )
  return data
}

const deletePerformanceOKR = async (payload) => {
  const { data } = await Axios.delete(`/mobile/performance-okrs/${payload}`)
  return data
}

//Smart Goals
const getPerformanceSmartGoals = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let source = payload.source ? '&source=' + payload.source : "&source=''"
  let source_id = payload.source_id ? '&source_id=' + payload.source_id : null
  const { data } = await Axios.get(
    `/mobile/performance-evaluation-smart-goals?limit=${payload.limit}&page=${payload.page}${search}${source}${source_id}`
  )
  return data?.data
}

const addPerformanceSmartGoals = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance-evaluation-smart-goals',
    payload
  )
  return data
}

const updatePerformanceSmartGoals = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/performance-evaluation-smart-goals/' + payload.id,
    payload.data
  )
  return data
}

const gradeSmartGoals = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/employee-grade-smart-goal',
    payload
  )
  return data
}

const gradeOkrs = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/employee-grade-okr',
    payload
  )
  return data
}

const gradeBalancedScoreCard = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/employee-grade-balanced-scorecard',
    payload
  )
  return data
}

const teamLeadGradeBalancedScoreCard = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/team-lead-grade-balanced-scorecard',
    payload
  )
  return data
}

//Technical Appraisals
const getTechnicalAppraisals = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let source = payload.source ? '&source=' + payload.source : "&source=''"
  let source_id = payload.source_id ? '&source_id=' + payload.source_id : null
  const { data } = await Axios.get(
    `/mobile/technical-appraisals?limit=${payload.limit}&page=${payload.page}${search}${source}${source_id}`
  )
  return data?.data
}

const addTechnicalAppraisal = async (payload) => {
  const { data } = await Axios.post('/mobile/technical-appraisals', payload)
  return data
}

const updateTechnicalAppraisal = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/technical-appraisals/' + payload.id,
    payload.data
  )
  return data
}

const gradeTechnicalAppraisal = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/employee-grade-technical-appraisal',
    payload
  )
  return data
}

const teamLeadGradeTechnicalAppraisal = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/team-lead-grade-technical-appraisal',
    payload
  )
  return data
}

const gradeOrganisationalAssessments = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/employee-grade-organisational-appraisals',
    payload
  )
  return data
}

const teamLeadGradeSmartGoals = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/team-lead-grade-smart-goal',
    payload
  )
  return data
}

const teamLeadGradeOkrs = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/team-lead-grade-okr',
    payload
  )
  return data
}

const teamLeadGradeOrganisationalAssessments = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/performance/evaluate/team-lead-grade-organisational-appraisals',
    payload
  )
  return data
}

const getAssignedPerformances = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/mobile/performances/fetch_assigned_evaluations?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

const getEvaluations = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/mobile/performances/fetch_evaluation_assessments?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

// Goals
const addGoal = async (payload) => {
  const { data } = await Axios.post('/mobile/goals/create', payload)
  return data
}

const extendGoal = async (payload) => {
  const { data } = await Axios.post('/mobile/goals/add-extension', payload)
  return data
}

const extendSubGoal = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/goals/sub-goal/add-extension',
    payload
  )
  return data
}

const addRemoveMember = async (payload) => {
  const { data } = await Axios.post('/mobile/goals/update-members', payload)
  return data
}

const addRemoveAssignee = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/goals/sub-goals/update/assignees',
    payload
  )
  return data
}

const markSubGoal = async (payload) => {
  const { data } = await Axios.put('/mobile/goals/sub-goals/mark', payload)
  return data
}

const membersPermission = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/goals/member/set-permission/' + payload.id,
    payload.data
  )
  return data
}

const markGoal = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/goals/mark/' + payload.id,
    payload.data
  )
  return data
}

const reviewSubGoal = async (payload) => {
  const { data } = await Axios.put('/mobile/goals/sub-goals/review', payload)
  return data
}

const deleteSubGoal = async (payload) => {
  const { data } = await Axios.delete('/mobile/goals/delete-sub-goals', {
    data: payload,
  })
  return data
}

const deleteGoal = async (payload) => {
  const { data } = await Axios.delete('/mobile/goals/delete-goals', {
    data: payload,
  })
  return data
}

const getGoals = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  const { data } = await Axios.get(
    `/mobile/goals/fetch-company-goals?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}

const getSingleGoal = async (payload) => {
  const { data } = await Axios.get(
    `/mobile/goals/fetch-single-company-goal/${payload.id}`
  )
  return data?.data
}

const getTeamGoals = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  const { data } = await Axios.get(
    `/mobile/goals/fetch?limit=${payload.limit}&page=${payload.page}${search}`
  )
  return data?.data
}

const getSingleTeamGoal = async (payload) => {
  const { data } = await Axios.get(
    `/mobile/goals/fetch-single-goal/${payload.id}`
  )
  return data?.data
}
const editSubGoal = async (payload) => {
  const { data } = await Axios.put('/mobile/goals/update-sub-goal', payload)
  return data
}

const updateGoal = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/goals/update-goal/' + payload.id,
    payload.data
  )
  return data
}

const addSubGoal = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/goals/sub-goals/add/' + payload.id,
    payload.data
  )
  return data
}

const editGoalsInfo = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/goals/update/' + payload.id,
    payload.data
  )
  return data
}

export const performances = {
  evaluatePerformance,
  advancedEvaluatePerformance,
  getPerformances,
  getPerformancesBySource,
  getPerformanceSummary,
  gradeBasicPerformance,
  getPerformance,
  getPerformanceBySource,
  deletePerformance,
  getPerformancesByEmployee,
  getPerformanceWorkflows,
  getPerformanceWorkflow,
  addPerformanceWorkflow,
  updatePerformanceWorkflow,
  updateTrainingRequirements,
  updateReviewerComment,
  getPerformanceOkrs,
  addPerformanceOKR,
  updatePerformanceOKR,
  deletePerformanceOKR,
  getPerformanceSmartGoals,
  addPerformanceSmartGoals,
  updatePerformanceSmartGoals,
  gradeSmartGoals,
  gradeOkrs,
  gradeOrganisationalAssessments,
  teamLeadGradeSmartGoals,
  teamLeadGradeOkrs,
  teamLeadGradeOrganisationalAssessments,

  getTechnicalAppraisals,
  addTechnicalAppraisal,
  updateTechnicalAppraisal,
  gradeTechnicalAppraisal,
  teamLeadGradeTechnicalAppraisal,

  gradeBalancedScoreCard,
  teamLeadGradeBalancedScoreCard,
  getAssignedPerformances,
  getEvaluations,
  addGoal,
  getGoals,
  getSingleGoal,
  markSubGoal,
  deleteSubGoal,
  deleteGoal,
  addRemoveMember,
  addRemoveAssignee,
  reviewSubGoal,
  membersPermission,
  markGoal,
  extendGoal,
  extendSubGoal,
  getTeamGoals,
  getSingleTeamGoal,
  editSubGoal,
  updateGoal,
  addSubGoal,
  editGoalsInfo,
}
